import { StackActions, useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';
import { RootNavProps } from 'types/navigation';

const useAfterVehicleRedirect = () => {
  const { dispatch } = useNavigation<RootNavProps>();

  const navigateAfterVehicleSaved = useCallback(() => {
    dispatch(StackActions.pop());
  }, [dispatch]);

  return { navigateAfterVehicleSaved };
};

export default useAfterVehicleRedirect;
